import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeDatabase extends Shape {
    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width - 2 * horizontalPadding;
        const allowedHeight = (height * 3) / 4 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 6, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 30;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.ellipse(x + width / 2, y + height / 8, width / 2, height / 8, 0, 0, 2 * Math.PI);
        canv.ctx.closePath();
        canv.ctx.moveTo(x, y + height / 8);
        canv.ctx.lineTo(x, y + (height * 15) / 16);
        canv.ctx.ellipse(
            x + width / 2,
            y + (height * 15) / 16,
            width / 2,
            height / 16,
            0,
            Math.PI,
            2 * Math.PI,
            true,
        );
        canv.ctx.lineTo(x + width, y + height / 8);
        canv.ctx.ellipse(x + width / 2, y + height / 8, width / 2, height / 8, 0, 0, 2 * Math.PI);
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}"d="M0 0h24v24H0z"/>
                <path stroke="${stroke}" d="M1.1 4c-.2.6-.1 15.5 0 15.9 1.2 4.1 21.4 4.1 21.8 0 0-.3.2-15.3 0-16M1.1 4c1-3.7 20.6-4 21.8 0M1.1 4c1.9 3.3 20 3.3 21.8 0"/>
            </svg>

        `;
    }
}
